export const headerStyles = ({ id }) => {
	switch (id) {
		case "select":
			return {
				background: "#bde3ff",
				width: "1%",
			};
		case "loadingDate":
		case "loadingAddress":
			return { background: "#bde3ff" };
		case "unloadingDate":
		case "unloadingAddress":
			return { background: "#39acff" };
		case "offers":
			return { background: "#c5cbd7", textAlign: "center" };
		case "actions":
			return {
				background: "#fff",
				textAlign: "center",
				width: "1%",
				borderBottom: "none",
			};
		case "offers-actions":
			return {
				background: "#c5cbd7",
				textAlign: "center",
				width: "1%",
				borderBottom: "none",
			};
		default:
			return { background: "#e2e9f1", textAlign: "center" };
	}
};

export const cellsStyles = ({ id }) => {
	switch (id) {
		case "select":
			return;
		case "loadingDate":
		case "loadingAddress":
			return;
		case "unloadingDate":
		case "unloadingAddress":
			return;
		case "offers":
			return;
		case "actions":
			return;
		default:
			return { textAlign: "center" };
	}
};
